import { vuexSimple } from '@/helpers';
import media from '@/store/media';
export default vuexSimple(
  {
    ...media,
    actions: {
      ...media.actions,
      async fetchMedia({ dispatch }) {
        return await dispatch('fetchMedia', 'tweet', { root: true });
      }
    }
  },
  {
    // tags: null,
    collapse: false,
    tags: {},
    selectedTags: {},
    sectors: [],
    selectedSectors: [],
    types: [],
    categories: [],
    selectedCategories: [],
    sourceIds: [],
    selectedSourceIds: {},
    age: [0, 5],
    sentiment: [0, 5],
    interestingness: [0, 5],
    visuality: [0, 5],
    sourcePopularity: [0, 5],
    default_age: null,
    default_sentiment: null,
    default_interestingness: null,
    default_visuality: null,
    default_sourcePopularity: null
  }
);
